/* istanbul ignore file */
import paramsUtils from '@lib/params'
import url from '@lib/url'
import { URL_PARAMS } from '@lib/url/constants'
import { SubscriptionFormData } from '@pages/Subscription/hooks/useInitialFormValues'
import { ParamsStore } from '@stores/params'

export interface SubscriptionParams {
  subscriptionStart: string
  retailerPartnerNumber: number
  marketingCarrierCode: string | null
  additionalParams?: Record<string, any>
}

export default (params: SubscriptionParams): string => {
  const parameters = {
    retailerPartnerNumber: params.retailerPartnerNumber,
    marketingCarrierCode: params.marketingCarrierCode,
    subscriptionStart: params.subscriptionStart,
    ...params.additionalParams,
  }

  return url.build(['/', 'subscription'], parameters)
}

export const buildConfirmationPageUrl = (params: ParamsStore, orderId: string): string => {
  const persistentParams = paramsUtils.getPersistentUrlParams(params)

  return url.build(['', `/subscriptions/confirmation/${orderId}`], persistentParams)
}

export const buildSubscriptionReturnUrl = (
  pageParams: Partial<ParamsStore>,
  transactionId: string,
  formData?: SubscriptionFormData | null,
  subscriptionId?: string,
): string => {
  const urlParams = {
    retailerPartnerNumber: pageParams.retailerPartnerNumber,
    marketingCarrierCode: pageParams.marketingCarrierCode,
    [URL_PARAMS.RETURN_FROM_3DS]: 'true',
    [URL_PARAMS.TRANSACTION_ID]: transactionId,
    ...(formData && {
      paymentMethod: formData.paymentMethod,
      paymentProvider: formData.paymentProvider,
      subscriptionStart: formData.startMonth,
    }),
  }

  const returnPath = subscriptionId ? `/subscription/${subscriptionId}` : '/subscription'

  const baseUrl = url.build(['', returnPath], urlParams)
  return baseUrl.startsWith('http') ? baseUrl : `${window.location.origin}${baseUrl}`
}
